import { defineMessages } from 'react-intl';

const messages: {
	approvals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	downIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	home: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	more: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requests: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	downIcon: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
		defaultMessage: 'Open dropdown',
		description:
			'Accessible label for the chevron-down icon button in the company hub navbar that opens a navigation dropdown.',
	},
	home: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.home',
		defaultMessage: 'Home',
		description:
			'Text shown as the Home navigation link in the company hub top navbar, taking users to the hub home page.',
	},
	more: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.more',
		defaultMessage: 'More',
		description:
			'Text shown as the More navigation link in the company hub top navbar, opening a dropdown with additional custom pages.',
	},
	portals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
		defaultMessage: 'Portals',
		description: 'Navigation link label for the portals page',
	},
	requests: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.requests',
		defaultMessage: 'Requests',
		description:
			'Text shown as the Requests navigation link in the company hub top navbar, taking users to their submitted support requests.',
	},
	approvals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.approvals',
		defaultMessage: 'Approvals',
		description: 'Navigation link label for user approvals',
	},
});

export default messages;
